class TabbedSwiper {
  constructor(rootId, options = {}) {
    this.$root = $(`#${rootId}`);
    if (!this.$root.length) return;

    this.renderSlides = options.renderSlides;
    this.activeTabClasses = `tab-active ${options.activeTabClasses}`;
    this.swiperOptions = options.swiperOptions || {};
    this.swiper = null;
    this.movingBackward = false;

    this._bindEvents();
    const firstCategory = this._$('.trusted-tabs li').first().data('category');
    const $wrapper = this._$('.swiper-wrapper');
    $wrapper.empty();
    this.renderSlides(firstCategory, $wrapper);
    this._initSwiper();
  }

  _$(selector) {
    return this.$root.find(selector);
  }

  _initSwiper() {
    if (this.swiper) this.swiper.destroy(true, true);
    const self = this;
    this.swiper = new Swiper(this._$('.swiper-container')[0], Object.assign({
      speed: 600,
      autoplay: { delay: 5000, disableOnInteraction: false },
      initialSlide: this.movingBackward ? this._$('.swiper-slide').length - 1 : 0,
      on: {
        touchEnd() {
          const diff = self.swiper.touches.diff;
          if (self.swiper.isEnd && diff < 0) self._advanceTab(1);
          if (self.swiper.isBeginning && diff > 0) {
            self.movingBackward = true;
            self._advanceTab(-1);
          }
        },
        autoplay() {
          if (self.swiper.activeIndex === 0) self._advanceTab(1);
        },
      }
    }, this.swiperOptions));
    if (this.movingBackward) {
      this.swiper.slideTo(this.swiper.slides.length - 1);
      this.movingBackward = false;
    }
  }

  _animateCategorySwitch(category) {
    const $outer = this._$('.slide-outer');
    $outer.removeClass('tw-opacity-100').addClass('tw-opacity-0');
    setTimeout(() => {
      const $wrapper = this._$('.swiper-wrapper');
      $wrapper.empty();
      this.renderSlides(category, $wrapper);
      this._initSwiper();
      $outer.removeClass('tw-opacity-0').addClass('tw-opacity-100');
    }, 300);
  }

  _advanceTab(direction) {
    const $tabs = this._$('.trusted-tabs li');
    let i = this._$('.trusted-tabs li.tab-active').index() + direction;
    if (i >= $tabs.length) i = 0;
    if (i < 0) i = $tabs.length - 1;
    this._activateTab($tabs[i]);
  }
  _activateTab(tab) {
      const category = $(tab).data('category');
      this._$('.trusted-tabs li').removeClass(this.activeTabClasses);
      this._$(`.trusted-tabs li[data-category="${category}"]`).addClass(this.activeTabClasses);
      this._animateCategorySwitch(category);
  }

  _bindEvents() {
    const self = this;

    this._$('.trusted-tabs li').on('click', (e) => {
      this._activateTab(e.currentTarget);
    });

    this._$('.nav-next').on('click', function () {
      if (!self.swiper) return;
      if (self.swiper.isEnd) {
        self._advanceTab(1);
      } else {
        self.swiper.slideNext();
      }
    });

    this._$('.nav-prev').on('click', function () {
      if (!self.swiper) return;
      if (self.swiper.isBeginning) {
        self.movingBackward = true;
        self._advanceTab(-1);
      } else {
        self.swiper.slidePrev();
      }
    });
  }
}

TabbedSwiper.fromTemplates = function (rootId, swiperOptions) {
  return new TabbedSwiper(rootId, {
    activeTabClasses: 'tw-bg-brand-150 tw-border-brand-150 tw-font-normal',
    renderSlides(category, $container) {
      const tpl = document.querySelector(`#${rootId} template[data-category="${CSS.escape(category)}"]`);
      if (tpl) $container.append(tpl.content.cloneNode(true));
    },
    swiperOptions: swiperOptions || {},
  });
};

// Expose so template inline scripts (`new TabbedSwiper(...)` in home.html,
// global-payments.html, home/global_reach.html, home/trusted_by.html,
// home/enterprise.html) and esbuild bundles see the same TabbedSwiper.
window.TabbedSwiper = TabbedSwiper;
